import { createSlice } from "@reduxjs/toolkit";
import { isBoolean } from "../../../utils/utils";

const commonSlice = createSlice({
  name: "commonInfo",
  initialState: {
    signUpModalOpen: false,
    affiliateRef: null,
    autoPlay: isBoolean(JSON.parse(localStorage.getItem("autoPlay")))
      ? JSON.parse(localStorage.getItem("autoPlay"))
      : true,
    feedMuted: isBoolean(JSON.parse(localStorage.getItem("feedMuted")))
      ? JSON.parse(localStorage.getItem("feedMuted"))
      : true,

    isModalOpened: false,
    collectionTabAnimating: false,
  },
  reducers: {
    setSignUpModalOpen: (state, action) => {
      state.signUpModalOpen = action.payload;
    },
    setAutoPlay: (state, action) => {
      state.autoPlay = action.payload;
      localStorage.setItem("autoPlay", JSON.stringify(action.payload));
    },
    setFeedMuted: (state, action) => {
      state.feedMuted = action.payload;
      localStorage.setItem("feedMuted", JSON.stringify(action.payload));
    },
    setAffiliateRef: (state, action) => {
      state.affiliateRef = action.payload;
    },
    triggerCollectionTabAnimation: (state) => {
      state.collectionTabAnimating = true;
    },
    resetCollectionTabAnimation: (state) => {
      state.collectionTabAnimating = false;
    },
  },
  extraReducers: (builder) => {},
});

export const {
  setSignUpModalOpen,
  setAffiliateRef,
  setIsModalOpened,
  resetCollectionTabAnimation,
  setAutoPlay,
  setFeedMuted,
  triggerCollectionTabAnimation,
} = commonSlice.actions;

export const selectSignUpModalOpen = (state) =>
  state.commonInfo.signUpModalOpen;
export const selectAffiliateRef = (state) => state.commonInfo.affiliateRef;
export const selectCollectionTabAnimating = (state) =>
  state.commonInfo.collectionTabAnimating;

export const selectAutoPlay = (state) => state.commonInfo.autoPlay;

export const selectFeedMuted = (state) => state.commonInfo.feedMuted;

export default commonSlice.reducer;
